import { render, staticRenderFns } from "./manage-practice-template-page.vue?vue&type=template&id=edfed52a&scoped=true"
import script from "./manage-practice-template-page.vue?vue&type=script&lang=js"
export * from "./manage-practice-template-page.vue?vue&type=script&lang=js"
import style0 from "./manage-practice-template-page.vue?vue&type=style&index=0&id=edfed52a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edfed52a",
  null
  
)

export default component.exports